export const TABS = {
  DASHBOARD: 'Dashboard',
  SESSIONS: 'Sessions',
  PERFORMANCE: 'Performance',
};

export const TAB_ACTIVE_STYLES = {
  padding: '10px 20px',
  borderRadius: '16px',
  backgroundColor: '#467093',
  fontWeight: '700',
  color: '#FFFFFF',
  fontSize: '16px',
  textAlign: 'center',
  textDecoration: 'none',
  outline: 'none 0',
  border: '1px solid #467093',
  textTransform: 'none',
  marginRight: '16px',
  maxHeight: '42px'
};
export const TAB_STYLES = {
  padding: '10px 20px',
  borderRadius: '16px',
  backgroundColor: '#FAFCFE',
  fontWeight: '700',
  color: '#2B3538',
  fontSize: '16px',
  textAlign: 'center',
  textDecoration: 'none',
  outline: 'none 0',
  border: '1px solid #DAE6F3',
  textTransform: 'none',
  margin: '0 8px',
  maxHeight: '42px'
};

export const FilterTypes = {
  'all_questions': 'All Questions',
  'unseen': 'Not Seen Before',
  'wrong': 'Wrong Before',
};



// WEBPACK FOOTER //
// ./src/modules/mcq/constants.js